import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 5px;
  box-shadow: -5px 5px 5px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease;
  border-radius: 2px;
`;

export const imageStyle = {
  minWidth: '100px',
  minHeight: '100px',
  radius: 12,
};
